import React, { Component } from "react";
import { connect } from "react-redux";
import { Container, Row, Col } from "reactstrap";
import Ink from "react-ink";

import api from "../../config/api";
import "./style.css";
import StepTab from "./StepTab";
import BankDetails from "./BankDetails";
import PersonalDetail from "./PersonalDetail";
import Residence from "./Residence";
import Employer from "./Employer";
import NextOfKin from "./NextOfKin";
import Signature from "./Signature";
import Picture from "./Picture";
// import ConsentForm from "./ConsentForm";
import historyAction from "../../redux/history/action";
import onboardingAction from "../../redux/onboarding/action";
import mpAction from "../../redux/microPensionDublicated/action";
import PageHead from "../../component/pageHead/PageHead";
import CustomLoader from "../../component/CustomLoader/CustomLoader";
import nextBlueIcon from "../../assets/icons/Conti_blue.png";
import prevBlueIcon from "../../assets/icons/back_blue.png";
import authAction from "../../redux/auth/action";

class Onboarding extends Component {
  state = {
    step: 1,
    isLoading: false,
  };

  componentDidMount() {
    const { history, setHistory } = this.props;

    this.validate();
    this.fetchCountries();

    setHistory(history);
  }

  fetchCountries = async () => {
    try {
      const { saveCountries } = this.props;
      const response = await api.fetchCountries();

      saveCountries(response.data.result);
    } catch (e) {
      console.log("Error", e.message);
    }
  };

  validate = async () => {
    const { validateUser, user, getUser } = this.props;

    if (!validateUser.userName) {
      this.setState({ isLoading: true });

      try {
        const response = await api.getUsernameAndPassword(
          { userName: user.User.userName },
          user.token
        );
        const data = {
          userName: response.data.result.UserName,
          password: response.data.result.Password,
        };
        getUser(data);
      } catch (e) {
        console.log("Error", e.message);
      }
      this.setState({ isLoading: false });
    }
  };

  scrollToTop = () => {
    const target = document.querySelector(".card-container .flex1");
    var maxScroll = target.scrollHeight;

    var scrollInt = setInterval(() => {
      if (target.scrollTop !== 0) {
        target.scrollTop -= maxScroll / 100;
      } else {
        clearInterval(scrollInt);
      }
    }, 10);
  };

  decideTab = () => {
    const { step } = this.state;

    switch (step) {
      case 1:
        return (
          <PersonalDetail customRef={(el) => (this.personalDetail = el)} />
        );
      case 2:
        return <Residence customRef={(el) => (this.residence = el)} />;
      case 3:
        return <Employer customRef={(el) => (this.employer = el)} />;
      case 4:
        return <NextOfKin customRef={(el) => (this.nextOfKin = el)} />;
      case 5:
        return <BankDetails customRef={(el) => (this.bankDetails = el)} />;
      case 6:
        return <Signature customRef={(el) => (this.signature = el)} />;
      case 7:
        return <Picture customRef={(el) => (this.picture = el)} />;
      // case 8:
      //   return <ConsentForm customRef={el => (this.consentForm = el)} />;
      default:
        return;
    }
  };

  decideBottomBtnContainerClasses = () => {
    const { step } = this.state;

    let baseClass = "d-flex";
    if (step === 1) {
      baseClass = baseClass + " justify-content-end";
    } else if (step === 8) {
      baseClass = baseClass + " justify-content-start";
    } else {
      baseClass = baseClass + " justify-content-between";
    }

    return baseClass;
  };

  onStepChange = (step) => {
    const { step: currentStep } = this.state;
    const { setAlertMessage } = this.props;
    let isError = true;

    if (currentStep < step) {
      if (currentStep === 1) isError = this.personalDetail.validate();
      if (currentStep === 2) isError = this.residence.validate();
      if (currentStep === 3) isError = this.employer.validate();
      if (currentStep === 4) isError = this.nextOfKin.validate();
      if (currentStep === 5) isError = this.bankDetails.validate();
      if (currentStep === 6) isError = this.signature.validate();
      if (currentStep === 7) isError = this.picture.validate();
    }

    if (!isError)
      return setAlertMessage({
        type: "error",
        message: "Please fill all required fields",
      });

    this.setState({ step }, () => this.scrollToTop());
  };

  render() {
    const { step, isLoading } = this.state;

    return (
      <Container>
        <PageHead
          leftText="ONBOARDING"
          rightText="COMPLETE ALL FIELDS"
          containerStyles={{ width: "100%" }}
        />
        <Row className="my-2 justify-content-center">
          <Col className="p-1 pl-sm-0" sm={6} md={3}>
            <StepTab
              onClick={this.onStepChange.bind(this, 1)}
              text="Personal Detail"
              active={step === 1}
            />
          </Col>
          <Col className="p-1" sm={6} md={3}>
            <StepTab
              onClick={this.onStepChange.bind(this, 2)}
              text="Residence"
              active={step === 2}
            />
          </Col>
          <Col className="p-1" sm={6} md={3}>
            <StepTab
              onClick={this.onStepChange.bind(this, 3)}
              text="Nature of Business"
              active={step === 3}
            />
          </Col>
          <Col className="p-1" sm={6} md={3}>
            <StepTab
              onClick={this.onStepChange.bind(this, 4)}
              text="Next of Kin"
              active={step === 4}
            />
          </Col>
          <Col className="p-1" sm={6} md={3}>
            <StepTab
              onClick={this.onStepChange.bind(this, 5)}
              text="Bank Details"
              active={step === 5}
            />
          </Col>
          <Col className="p-1" sm={6} md={3}>
            <StepTab
              onClick={this.onStepChange.bind(this, 6)}
              text="Signature"
              active={step === 6}
            />
          </Col>
          <Col className="p-1" sm={6} md={3}>
            <StepTab
              onClick={this.onStepChange.bind(this, 7)}
              text="Picture"
              active={step === 7}
            />
          </Col>
          {/* <Col className="p-1" sm={6} md={3}>
            <StepTab
              onClick={this.onStepChange.bind(this, 8)}
              text="Consent Form"
              active={step === 8}
            />
          </Col> */}
        </Row>
        {this.decideTab()}
        <div className={this.decideBottomBtnContainerClasses()}>
          {step !== 1 && (
            <div
              className="continue-btn-container my-3"
              onClick={this.onStepChange.bind(this, step - 1)}
            >
              <img alt="prevbutton" src={prevBlueIcon} width="20px" />
              <p className="text-center flex1 ml-2">Back</p>
              <Ink />
            </div>
          )}
          {step !== 7 && (
            <div
              className="continue-btn-container my-3"
              onClick={this.onStepChange.bind(this, step + 1)}
            >
              <p className="flex1 text-center mr-2">Continue</p>
              <img alt="nextbutton" src={nextBlueIcon} width="20px" />
              <Ink />
            </div>
          )}
        </div>
        {isLoading && <CustomLoader />}
      </Container>
    );
  }
}

const mapStateToProps = (state) => ({
  user: state.auth.user,
  validateUser: state.onboarding.user,
  formRefno: state.microPensionDublicated.personalDetail.formRefno,
});

const mapDispatchToProps = {
  setHistory: historyAction.setHistory,
  getUser: onboardingAction.getUser,
  saveCountries: onboardingAction.saveCountries,
  setAlertMessage: authAction.setAlertMessage,
  setPersonalDetailField: mpAction.setPersonalDetailField,
  resetForm: mpAction.resetRSAForm,
};

export default connect(mapStateToProps, mapDispatchToProps)(Onboarding);
